import { cn } from "@/lib/utils";

const VARIANTS = {
  // Campaign statuses
  active: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  draft: "text-neutral-400 bg-neutral-400/10 border-neutral-400/20",
  paused: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  completed: "text-sky-400 bg-sky-400/10 border-sky-400/20",
  // Inbox / lead statuses
  healthy: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  warning: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  critical: "text-red-400 bg-red-400/10 border-red-400/20",
  pending: "text-neutral-400 bg-neutral-400/10 border-neutral-400/20",
  replied: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  bounced: "text-red-400 bg-red-400/10 border-red-400/20",
  unsubscribed: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  error: "text-red-400 bg-red-400/10 border-red-400/20",
};

export default function StatusBadge({ status, className }) {
  const key = (status || "").toLowerCase();
  const v = VARIANTS[key] || VARIANTS.draft;
  return (
    <span
      data-testid={`status-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-mono uppercase tracking-[0.18em] border",
        v,
        className,
      )}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {status}
    </span>
  );
}
